/** Contract every arcade minigame implements; the host owns the loop, canvas and input. */
export type Button = 'left' | 'right' | 'up' | 'down' | 'a';

export interface ArcadeGame {
  /** Logical canvas size. */
  readonly w: number;
  readonly h: number;
  /** On-screen buttons to show under the canvas. */
  readonly buttons: readonly Button[];
  score: number;
  over: boolean;
  /** Optional: a won game shows "You win!". */
  won?: boolean;
  reset(): void;
  update(dt: number): void;
  draw(c: CanvasRenderingContext2D, t: number): void;
  press?(b: Button, down: boolean): void;
  pointer?(type: 'down' | 'move' | 'up', x: number, y: number): void;
  swipe?(dir: 'left' | 'right' | 'up' | 'down'): void;
  /** Score → stars (before the daily cap). */
  stars(score: number): number;
  /** Extra controls (DOM) rendered under the canvas, e.g. a colour palette. */
  extra?(): HTMLElement | null;
}

export function rr(c: CanvasRenderingContext2D, x: number, y: number, w: number, h: number, r: number, fill: string): void {
  c.fillStyle = fill;
  c.beginPath();
  c.roundRect(x, y, w, h, r);
  c.fill();
}

export function text(c: CanvasRenderingContext2D, s: string, x: number, y: number, size: number, color: string, align: CanvasTextAlign = 'center'): void {
  c.font = `800 ${size}px system-ui, "PingFang TC", "Noto Sans TC", sans-serif`;
  c.textAlign = align;
  c.textBaseline = 'middle';
  c.lineWidth = Math.max(2, size / 5);
  c.strokeStyle = 'rgba(20,10,6,0.6)';
  c.strokeText(s, x, y);
  c.fillStyle = color;
  c.fillText(s, x, y);
}
